export default "__VITE_ASSET__CyqU3V2O__"